module.exports = __webpack_public_path__ + "static/media/project4.36e11cc5.png";